export default function splitValue(value) {
    return (value || '').split('')
}